export default "__VITE_ASSET__D4_c3mNg__"